import { Box, Divider, Flex, Text } from '@vibe/core';
import { UploadPortalSettingsButton } from './UploadPortalSettingsButton';

type UploadPortalSettingsProps = {
  onUploaded: (newPortalSettings: any) => void;
};

function UploadPortalSettings({ onUploaded }: UploadPortalSettingsProps) {
  return (
    <Box
      marginTop="xxl"
      border={true}
      borderColor="layoutBorderColor"
      rounded="small"
      backgroundColor="greyBackgroundColor"
      shadow="xs"
      style={{
        width: 'calc(100% - 2px)',
      }}
    >
      <Flex direction="column" gap={0}>
        <Text
          type="text2"
          weight="medium"
          align="center"
          style={{ padding: '26px 16px', width: 'calc(100% - 32px)', backgroundColor: '#ffffff' }}
        >
          Import the settings file you received by email.
        </Text>
        <Divider withoutMargin />
        <Flex direction="row" gap={16} style={{ padding: '16px', width: 'calc(100% - 32px)' }}>
          <UploadPortalSettingsButton onUploaded={onUploaded} />
        </Flex>
      </Flex>
    </Box>
  );
}

export default UploadPortalSettings;
